module.exports = __webpack_public_path__ + "static/media/logo_nemali.5e83b60e.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/logo_nemali.png
// module id = 971
// module chunks = 0